import { render, staticRenderFns } from "./SelectGroupLevelItems.vue?vue&type=template&id=8ed217c0&scoped=true&"
import script from "./SelectGroupLevelItems.vue?vue&type=script&lang=js&"
export * from "./SelectGroupLevelItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed217c0",
  null
  
)

export default component.exports